import React, { useState, useEffect } from 'react';
import Box from '@mui/material/Box';
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import moment from 'moment';
import { useTranslation } from 'react-i18next';
import { useAppDispatch, useAppSelector } from '../../../redux/hooks';
import useMediaQuery from '@mui/material/useMediaQuery';

// Routes 
import { getSupportTickets } from '../../../routes/support/support';
import { getTicketDetails } from '../../../routes/support/support';

// Redux 
import { setSupportTicket } from '../../../redux/features/support/supportTicket';
import { setOpenPopup } from '../../../redux/features/general/popup';
import { setAuthorPersonalInfo } from '../../../redux/features/support/supportTicket';

// Components 
import SupportTicketHeader from './formItems/SupportTicketHeader';
import SupportTicketRow from './formItems/SupportTicketRow';
import SupportTicketCard from './formItems/SupportTicketCard';
import TicketDetails from './formItems/TicketDetails';
import Popup from '../../general/Popup';

// Icons 
import PersonAddAlt1Icon from '@mui/icons-material/PersonAddAlt1';

const SupportTicketsList: React.FC = () => {

    const { t } = useTranslation();
    
    const dispatch = useAppDispatch();

    const colors = useAppSelector(state => state.theme.colors);
    const isPopupOpened = useAppSelector((state) => state.popup.isPopupOpened); 
    const isMobile = useMediaQuery('(max-width:600px)');

    const [supportTickets, setSupportTickets] = useState(Array<any>);

    // -- 

    const getSupportTicketsList = async () => { 
      const res = await getSupportTickets() as any; 
      if (res.data.status === '200') { 
        setSupportTickets(res.data.supportTickets); 
      };
    }; 

    // -- 

    const selectSupportTicket = (supportTicket: any) => { 
      dispatch(setSupportTicket(supportTicket)); 
      dispatch(setOpenPopup()); 
      getAdditionalInfo(supportTicket.author); 
    }; 

    // --

    const getAdditionalInfo = async (author: string) => { 
      const res = await getTicketDetails(author) as any; 
      if (res.data.status === '200') { 
          const author = res.data.author as any; 
          dispatch(setAuthorPersonalInfo(author)); 
      };
    }; 

    // -- 

    useEffect(() => { 
        getSupportTicketsList(); 
    },[]); 
    
    // -- Render Functions for Desktop vs Mobile

    const renderDesktopView = () => (
      <Box sx={{ minWidth: '800px' }}>
        <SupportTicketHeader />
        <List dense>
          {supportTickets?.map((item, index) => (
            <ListItem onClick={() => selectSupportTicket(item)} button key={index}>
              <SupportTicketRow
                author={item.author} 
                ticketId={item._id}
                status={item.status} 
                category={item.category}
                description={item.description}
                createdAt={moment.utc(item.createdAt).format('LL')}
              /> 
            </ListItem>
          ))}
        </List>
      </Box>
    );

    const renderMobileView = () => (
      <Box sx={{ p: 2 }}>
        {supportTickets?.map((item, index) => (
          <SupportTicketCard 
            key={index}
            item={{...item, createdAt: moment.utc(item.createdAt).format('LL')}}
            onClick={() => selectSupportTicket(item)}
          />
        ))}
      </Box>
    );

    return (
        <Box sx={{ width: '100%', height: '100%', overflow: 'auto', scrollbarWidth: 'none' }}>

            { supportTickets?.length >= 1 && (
              isMobile ? renderMobileView() : renderDesktopView()
            )}

            {supportTickets?.length === 0 &&         
              <Box sx={{ 
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                justifyContent: 'center',
                height: '100%',
                width: '100%',
                color: colors?.text
              }}>
                <PersonAddAlt1Icon sx={{ fontSize: 70 }} />
                <div>{t('noSupportTickets')}</div>
              </Box>
            }

            { isPopupOpened && 
              <Popup>
                <TicketDetails />
              </Popup>
            }
        </Box>
    );
};

export default SupportTicketsList;